import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, s as setBearerAuthToObject, a as assertParamExists, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * AccountApi - axios parameter creator
 * @export
 */
const AccountApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Issues a one-shot, short-lived admin-SSO ticket carrying the current admin\'s identity so the storefront can redeem it for an admin session (e.g. for the page-builder). Any authenticated admin user may request one — the minted session carries the user\'s own role/permissions, so each storefront endpoint still enforces its own authorization. (Auth policies: Admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminSsoTicket: async (options = {}) => {
            const localVarPath = `/v1/Account/CreateAdminSsoTicket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer: async (options = {}) => {
            const localVarPath = `/v1/Account/DeleteCustomer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: CanImpersonate)
         * @param {number} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonateCustomer: async (customerId, options = {}) => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('impersonateCustomer', 'customerId', customerId);
            const localVarPath = `/v1/Account/ImpersonateCustomer/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: CanImpersonate)
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonateGuest: async (email, options = {}) => {
            const localVarPath = `/v1/Account/ImpersonateGuest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {LoginArgs} [LoginArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (LoginArgs, options = {}) => {
            const localVarPath = `/v1/Account/Login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(LoginArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (RefreshTokenArgs, options = {}) => {
            const localVarPath = `/v1/Account/Logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RefreshTokenArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Redeems an admin-SSO ticket (one-shot) and returns a fresh admin session. Anonymous, because the caller is not yet authenticated on the storefront origin — the ticket is the credential.
         * @param {RedeemAdminSsoTicketArgs} [RedeemAdminSsoTicketArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemAdminSsoTicket: async (RedeemAdminSsoTicketArgs, options = {}) => {
            const localVarPath = `/v1/Account/RedeemAdminSsoTicket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RedeemAdminSsoTicketArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (RefreshTokenArgs, options = {}) => {
            const localVarPath = `/v1/Account/RefreshToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RefreshTokenArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountApi - functional programming interface
 * @export
 */
const AccountApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Issues a one-shot, short-lived admin-SSO ticket carrying the current admin\'s identity so the storefront can redeem it for an admin session (e.g. for the page-builder). Any authenticated admin user may request one — the minted session carries the user\'s own role/permissions, so each storefront endpoint still enforces its own authorization. (Auth policies: Admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdminSsoTicket(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdminSsoTicket(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.createAdminSsoTicket']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomer(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomer(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.deleteCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: CanImpersonate)
         * @param {number} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async impersonateCustomer(customerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.impersonateCustomer(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.impersonateCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: CanImpersonate)
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async impersonateGuest(email, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.impersonateGuest(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.impersonateGuest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {LoginArgs} [LoginArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(LoginArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(LoginArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(RefreshTokenArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(RefreshTokenArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Redeems an admin-SSO ticket (one-shot) and returns a fresh admin session. Anonymous, because the caller is not yet authenticated on the storefront origin — the ticket is the credential.
         * @param {RedeemAdminSsoTicketArgs} [RedeemAdminSsoTicketArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redeemAdminSsoTicket(RedeemAdminSsoTicketArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redeemAdminSsoTicket(RedeemAdminSsoTicketArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.redeemAdminSsoTicket']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(RefreshTokenArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(RefreshTokenArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AccountApi - factory interface
 * @export
 */
const AccountApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountApiFp(configuration);
    return {
        /**
         *
         * @summary Issues a one-shot, short-lived admin-SSO ticket carrying the current admin\'s identity so the storefront can redeem it for an admin session (e.g. for the page-builder). Any authenticated admin user may request one — the minted session carries the user\'s own role/permissions, so each storefront endpoint still enforces its own authorization. (Auth policies: Admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminSsoTicket(options) {
            return localVarFp.createAdminSsoTicket(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer(options) {
            return localVarFp.deleteCustomer(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: CanImpersonate)
         * @param {number} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonateCustomer(customerId, options) {
            return localVarFp.impersonateCustomer(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: CanImpersonate)
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonateGuest(email, options) {
            return localVarFp.impersonateGuest(email, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LoginArgs} [LoginArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(LoginArgs, options) {
            return localVarFp.login(LoginArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(RefreshTokenArgs, options) {
            return localVarFp.logout(RefreshTokenArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Redeems an admin-SSO ticket (one-shot) and returns a fresh admin session. Anonymous, because the caller is not yet authenticated on the storefront origin — the ticket is the credential.
         * @param {RedeemAdminSsoTicketArgs} [RedeemAdminSsoTicketArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemAdminSsoTicket(RedeemAdminSsoTicketArgs, options) {
            return localVarFp.redeemAdminSsoTicket(RedeemAdminSsoTicketArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(RefreshTokenArgs, options) {
            return localVarFp.refreshToken(RefreshTokenArgs, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
class AccountApi extends BaseAPI {
    /**
     *
     * @summary Issues a one-shot, short-lived admin-SSO ticket carrying the current admin\'s identity so the storefront can redeem it for an admin session (e.g. for the page-builder). Any authenticated admin user may request one — the minted session carries the user\'s own role/permissions, so each storefront endpoint still enforces its own authorization. (Auth policies: Admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    createAdminSsoTicket(options) {
        return AccountApiFp(this.configuration).createAdminSsoTicket(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    deleteCustomer(options) {
        return AccountApiFp(this.configuration).deleteCustomer(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: CanImpersonate)
     * @param {number} customerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    impersonateCustomer(customerId, options) {
        return AccountApiFp(this.configuration).impersonateCustomer(customerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: CanImpersonate)
     * @param {string} [email]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    impersonateGuest(email, options) {
        return AccountApiFp(this.configuration).impersonateGuest(email, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LoginArgs} [LoginArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    login(LoginArgs, options) {
        return AccountApiFp(this.configuration).login(LoginArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RefreshTokenArgs} [RefreshTokenArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    logout(RefreshTokenArgs, options) {
        return AccountApiFp(this.configuration).logout(RefreshTokenArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Redeems an admin-SSO ticket (one-shot) and returns a fresh admin session. Anonymous, because the caller is not yet authenticated on the storefront origin — the ticket is the credential.
     * @param {RedeemAdminSsoTicketArgs} [RedeemAdminSsoTicketArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    redeemAdminSsoTicket(RedeemAdminSsoTicketArgs, options) {
        return AccountApiFp(this.configuration).redeemAdminSsoTicket(RedeemAdminSsoTicketArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RefreshTokenArgs} [RefreshTokenArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    refreshToken(RefreshTokenArgs, options) {
        return AccountApiFp(this.configuration).refreshToken(RefreshTokenArgs, options).then((request) => request(this.axios, this.basePath));
    }
}

export { AccountApi, AccountApiAxiosParamCreator, AccountApiFactory, AccountApiFp };
//# sourceMappingURL=account-api.js.map
